import { BaseStorage } from './baseStorage';
import { RCXLogger } from '../logger';
import { ChatLink, CallLog } from '../typing';

export class ChatLogStorage extends BaseStorage<ChatLink> {
    getStorageConfig() {
        return {
            storeName: 'chat_crm_link',
        };
    }
    async saveChatLog(id: string, chatLog: any): Promise<CallLog | undefined> {
        try {
            const data = await this.save(id, { uii: id, crmChatLog: chatLog });
            return data.crmChatLog;
        } catch (error) {
            RCXLogger.getInstance().error('saveChatLog', error);
            return undefined;
        }
    }
    async updateChatLogAndContact(id: string, chatLog: any, contact: any): Promise<CallLog | undefined> {
        try {
            const data = await this.update(id, { uii: id, crmChatLog: chatLog, crmContact: contact });
            return data.crmChatLog;
        } catch (error) {
            RCXLogger.getInstance().error('updateChatLogAndContact', error);
            return undefined;
        }
    }
    async getChatLog(id: string) {
        return (await this.get(id))?.crmChatLog;
    }
}
export default new ChatLogStorage();
